(function () {
  if (window.SockscarvingBundleConfetti) return;

  function fire(button, celebrationClass) {
    if (!button) return;

    if (celebrationClass) {
      button.classList.remove(celebrationClass);
      void button.offsetWidth;
      button.classList.add(celebrationClass);
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setTimeout(function () {
        if (celebrationClass) button.classList.remove(celebrationClass);
      }, 900);
      return;
    }

    const buttonRect = button.getBoundingClientRect();
    const originX = buttonRect.left + (buttonRect.width / 2);
    const originY = buttonRect.top + (buttonRect.height / 2);
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;

    const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    canvas.width = viewportWidth * pixelRatio;
    canvas.height = viewportHeight * pixelRatio;
    canvas.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000;';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    context.scale(pixelRatio, pixelRatio);

    const colors = ['#ff3b6b', '#ff9f1c', '#ffd60a', '#39e75f', '#19c3ff', '#8b5cf6', '#ef4dff'];
    const particleCount = viewportWidth < 750 ? 115 : 175;
    const particles = [];

    for (let index = 0; index < particleCount; index += 1) {
      particles.push({
        x: originX + ((Math.random() - 0.5) * 18),
        y: originY + ((Math.random() - 0.5) * 10),
        vx: -11 + (Math.random() * 17),
        vy: -18 - (Math.random() * 8),
        gravity: 0.22 + (Math.random() * 0.13),
        drag: 0.988 + (Math.random() * 0.007),
        width: 4 + (Math.random() * 7),
        height: 7 + (Math.random() * 9),
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * Math.PI * 2,
        rotationSpeed: (Math.random() - 0.5) * 0.42,
        tilt: Math.random() * Math.PI * 2,
        tiltSpeed: 0.08 + (Math.random() * 0.18),
        delay: Math.floor(Math.random() * 26),
        age: 0,
        life: 185 + Math.floor(Math.random() * 75),
        circle: Math.random() < 0.16
      });
    }

    let previousFrameTime = performance.now();
    function drawConfettiFrame(frameTime) {
      const frameStep = Math.min((frameTime - previousFrameTime) / 16.667, 2);
      previousFrameTime = frameTime;
      context.clearRect(0, 0, viewportWidth, viewportHeight);
      let activeParticles = 0;

      particles.forEach(function (particle) {
        if (particle.delay > 0) {
          particle.delay -= frameStep;
          activeParticles += 1;
          return;
        }

        particle.age += frameStep;
        particle.vx *= Math.pow(particle.drag, frameStep);
        particle.vy += particle.gravity * frameStep;
        particle.x += particle.vx * frameStep;
        particle.y += particle.vy * frameStep;
        particle.rotation += particle.rotationSpeed * frameStep;
        particle.tilt += particle.tiltSpeed * frameStep;

        if (particle.age >= particle.life || particle.y > viewportHeight + 50) return;
        activeParticles += 1;

        const fadeStart = particle.life * 0.72;
        const opacity = particle.age > fadeStart
          ? Math.max(0, 1 - ((particle.age - fadeStart) / (particle.life - fadeStart)))
          : 1;
        const flipScale = Math.max(0.18, Math.abs(Math.cos(particle.tilt)));

        context.save();
        context.globalAlpha = opacity;
        context.translate(particle.x, particle.y);
        context.rotate(particle.rotation);
        context.fillStyle = particle.color;
        if (particle.circle) {
          context.beginPath();
          context.arc(0, 0, particle.width * 0.55, 0, Math.PI * 2);
          context.fill();
        } else {
          context.scale(flipScale, 1);
          context.fillRect(
            -particle.width / 2,
            -particle.height / 2,
            particle.width,
            particle.height
          );
        }
        context.restore();
      });

      if (activeParticles > 0) requestAnimationFrame(drawConfettiFrame);
      else canvas.remove();
    }

    requestAnimationFrame(drawConfettiFrame);
    window.setTimeout(function () {
      if (celebrationClass) button.classList.remove(celebrationClass);
    }, 900);
  }

  window.SockscarvingBundleConfetti = { fire: fire };
})();
